/* istanbul ignore next */
export class ThriveLog {
    contentType: string;
    position: string;
    message: any;
    thriveIdentifier: string;
    domain: string;
    uniqueIdentifier: string;
    resourceInstance: string;
    container: string;
    destinationUrl: string;
    actionType: Â string;
    constructor() {
        this.contentType = '';
        this.position = '';
        this.message = '';
        this.thriveIdentifier = 'ThriveLogs';
        this.domain = '';
        this.uniqueIdentifier = '';
        this.resourceInstance = '';
        this.container = '';
        this.destinationUrl = '';
        this.actionType = '';
    }
}
